function ConsentCheckboxes({ smsConsent, setSmsConsent, termsConsent, setTermsConsent }) {
  return (
    <div className="consent-box">
      <label className="checkbox-group">
        <input
          type="checkbox"
          checked={smsConsent}
          onChange={(e) => setSmsConsent(e.target.checked)}
        />
        <span>
          I agree to receive SMS messages from Bluprint regarding time OTP and Forget Password
          updates. Message frequency varies. Message and data rates may apply. Text HELP for help.
          Text STOP to cancel.
        </span>
      </label>
      <label className="checkbox-group" style={{ marginBottom: 0 }}>
        <input
          type="checkbox"
          checked={termsConsent}
          onChange={(e) => setTermsConsent(e.target.checked)}
        />
        <span>
          I agree to the{' '}
          <a
            href="https://www.thebluprint.app/terms-conditions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>{' '}
          |{' '}
          <a
            href="https://www.thebluprint.app/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </span>
      </label>
    </div>
  );
}

export default ConsentCheckboxes;
